import { useAchievementTypes, useReduxState } from 'hooks';
import type { IconProp } from 'components/common/icons/Icon';

const useCompletionHistoryCustomFilters = () => {
  const { messages, serverConfig } = useReduxState();

  const achievementTypes = useAchievementTypes();

  const achievementsVisible = !serverConfig.hideAchievementsFromUI;
  const calendarEventsVisible = !serverConfig.hideCalendarEventsFromUI;
  const coursesVisible = !serverConfig.hideCoursesFromUI;
  const pathsVisible = !serverConfig.hidePathsFromUI;

  const individualAchievementsEnabled =
    serverConfig.individualAchievementsEnabled;

  const customFilters = [
    {
      allowMultiple: true,
      icon: 'check-circle' as IconProp,
      items: [
        ...(coursesVisible
          ? [{ label: messages.commonCourse, value: 'course' }]
          : []),
        ...(pathsVisible
          ? [{ label: messages.commonPath, value: 'path' }]
          : []),
        ...(calendarEventsVisible
          ? [{ label: messages.eventCalendarEvent, value: 'calendar-event' }]
          : []),
        ...(achievementsVisible
          ? [
              ...Object.keys(achievementTypes).map((achievementType) => ({
                label: achievementTypes[achievementType].title,
                value: achievementType
              })),
              ...(individualAchievementsEnabled
                ? [
                    {
                      label: messages.individualAchievement,
                      value: 'individual-achievement'
                    }
                  ]
                : [])
            ]
          : [])
      ].sort((a, b) => (a.label > b.label ? 1 : -1)),
      field: 'type',
      position: 0,
      title: messages.commonType
    },
    {
      allowMultiple: true,
      field: 'completionStatus',
      icon: ['far', 'clock'] as IconProp,
      items: [
        { label: messages.commonValid, value: 'valid' },
        { label: messages.commonExpired, value: 'expired' },
        { label: messages.profileTimelineUpcoming, value: 'upcoming' }
      ],
      position: 1,
      title: messages.commonStatus
    }
  ];

  return customFilters;
};

export default useCompletionHistoryCustomFilters;
